import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { OnBaseDocumentGroup } from '../../common/models/onBaseIntegrationAndMapping.model';

 
@Injectable()
export class UtilityService {

  constructor(public http: HttpClient) { }
     

    get(applicationNumber: string, state: boolean): Observable<string> {

        var res;
        if (state) {
            res = this.http.get<string>(`/api/flow/setApproveDate/${applicationNumber}`);
        }
        else {
            res = this.http.get<string>(`/api/flow/setPendingDenial/${applicationNumber}`);
        }     
     
     return res;
    }

    deleteNotifications(aged: number): Observable<number> {
        return this.http.delete<number>(`/api/systemNotifications/deleteAged/${aged}`);
    }

    processMessage(messageId: string): Observable<ProcessedMessageResponse> {
        return this.http.post<ProcessedMessageResponse>(`/api/docs/force-process-queue/`, messageId);
    }
}


export enum ProcessedMessageResult {
    DocumentUploaded,
    DocumentNotFound,    
    DocumentAlreadyUploaded,
    ErrorUploadingDocument
}

export interface ProcessedMessageResponse {
    responseCode: ProcessedMessageResult;
    message: string;
    stackTrace: string;
}